import { Link, useLocation } from "react-router-dom";
import "./navigation.styles.scss";

export const Navigation = () => {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="navigation__container">
        <Link to="/" className="navigation__logo">
          andrea dalila masó
        </Link>

        <ul className="navigation__menu">
          <li>
            <Link
              to="/"
              className={`navigation__link ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              home
            </Link>
          </li>
          <li>
            <Link
              to="/about"
              className={`navigation__link ${
                location.pathname === "/about" ? "active" : ""
              }`}
            >
              about
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};
